"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACRO_NAMES = void 0;
exports.MACRO_NAMES = [
    '$__time',
    '$__timeEpoch',
    '$__timeFilter',
    '$__timeFrom',
    '$__timeTo',
    '$__timeGroup',
    '$__timeGroupAlias',
    '$__unixEpochFilter',
    '$__unixEpochNanoFilter',
    '$__unixEpochNanoFrom',
    '$__unixEpochNanoTo',
    '$__unixEpochGroup',
    '$__unixEpochGroupAlias',
];
//# sourceMappingURL=constants.js.map